export default "/static/c85bffca75dc4321.svg"